import React, { useEffect, useState, useRef } from "react";
import { Modal, Typography, Col, Row, Tooltip } from "antd";
import styles from "assets/css/modals.module.css";
import { Formik } from "formik";
import { Form } from "antd";
import * as Yup from "yup";
import AppButton from "components/AppButton/AppButton";
import { inject, observer } from "mobx-react";
import { validAusNumberRegExpDeluxe, getFormatedContact, getFormatedContacts } from "constant/messageConstants";
import ContactSelector from "components/GatewayMessage/ContactSelector/ContactSelector";
import { isEmpty } from "lodash";

const validationSchema = Yup.object().shape({
  contacts: Yup.array()
    .of(
      Yup.string()
        .matches(validAusNumberRegExpDeluxe, "Invalid phone number")
        .nullable(true)
      // .required('Please add atleast one number')
    )
    .min(1, "Please add atleast one number")
    .max(20, "Maximum 20 numbers allowed")
    .nullable(true),
  numberList: Yup.array().nullable(true)
});

const TestSMS = props => {
  const { isVisible, handleCancel, sendGatewayMessage, authStore, isMms, name = "message", skip = false, isFirstTime, values, saveAndContinue, quickMessage = false, modalStore, contactStore } = props;

  const user = authStore.user;

  const formikRef = useRef();

  useEffect(() => {
    isVisible && user && user.mobile && modalStore.setData("quickSMSContact", getFormatedContact(user.mobile));
  }, [isVisible, user]);

  useEffect(() => {
    if (modalStore.isMms) {
      try {
        let defaultNum = modalStore.quickSMSContact
          ? getFormatedContacts([modalStore.quickSMSContact])
          : user && user.firstQuickMMS && user.mobile
          ? [...getFormatedContacts([user?.mobile]), ...formikRef.current?.values?.contacts].filter((item, index, self) => self.indexOf(item) === index)
          : formikRef.current?.values?.contacts;
        if (isEmpty(defaultNum)) defaultNum = [user.mobile];

        formikRef.current?.setFieldValue("contacts", defaultNum);

        const defaultContactData = [
          {
            label: user.firstName && user.lastName ? `${user.firstName} ${user.lastName} - ${defaultNum?.[0]}` : defaultNum?.[0],
            value: defaultNum?.[0],
            number: defaultNum?.[0],
            contactData: {
              first_name: user.firstName || "",
              last_name: user.lastName || ""
            }
          }
        ];

        formikRef.current?.setFieldValue("numberList", defaultContactData);
        contactStore.setSearchContacts(defaultContactData, true);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        let defaultNum = modalStore.quickSMSContact
          ? getFormatedContacts([modalStore.quickSMSContact])
          : user && user.firstQuickSMS && user.mobile
          ? [...getFormatedContacts([user?.mobile]), ...(formikRef.current?.values?.contacts ? formikRef.current?.values?.contacts : [])].filter((item, index, self) => self.indexOf(item) === index)
          : formikRef.current?.values?.contacts;
        if (isEmpty(defaultNum)) defaultNum = [user.mobile];

        formikRef.current?.setFieldValue("contacts", defaultNum);

        const defaultContactData = [
          {
            label: user.firstName && user.lastName ? `${user.firstName} ${user.lastName} - ${defaultNum?.[0]}` : defaultNum?.[0],
            value: defaultNum?.[0],
            number: defaultNum?.[0],
            contactData: {
              first_name: user.firstName || "",
              last_name: user.lastName || ""
            }
          }
        ];

        formikRef.current?.setFieldValue("numberList", defaultContactData);
        contactStore.setSearchContacts(defaultContactData, true);
      } catch (error) {
        console.log(error);
      }
    }
    if (formikRef.current?.resetForm) modalStore.setReset(formikRef.current?.resetForm);
  }, [modalStore.quickSMSContact]);

  if (!user) return null;

  const initialValues = {
    ...values,
    contacts: user?.mobile ? [user?.mobile] : [],
    numberList: user?.mobile
      ? [
          {
            label: user.firstName && user.lastName ? `${user.firstName} ${user.lastName} - ${user.mobile}` : user.mobile,
            value: user.mobile,
            number: user.mobile,
            contactData: {
              first_name: user.firstName || "",
              last_name: user.lastName || ""
            }
          }
        ]
      : []
  };

  return (
    <Modal
      destroyOnClose
      centered
      title={
        <div className="text-center">
          <h4 className="pt-3 fw-bold">Test {isMms ? "MMS" : "SMS"}</h4>
        </div>
      }
      closeIcon={
        <div className={`btn ${styles.modalCloseBtn}`}>
          <i className="fas fa-times"></i>
        </div>
      }
      visible={isVisible}
      onCancel={() => handleCancel()}
      width={600}
      footer={null}
      maskStyle={{
        background: "linear-gradient(135deg, #00000050, #107c9850)"
      }}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          // Create a new object without any scheduling-related fields
          const testValues = { ...values };
          const fieldsToRemove = [
            "scheduleAt",
            "activeTab",
            "dayOfMonth",
            "daysOfWeek",
            "endDate",
            "isSchedule",
            "monthWeek",
            "monthWeekDay",
            "monthlyType",
            "repeat",
            "repeatInterval",
            "startDate",
            "sendType",
            "senders",
            "senderType",
            "start_date",
            "end_date",
            "repetitive"
          ];

          fieldsToRemove.forEach(field => {
            if (field in testValues) delete testValues[field];
          });
          await sendGatewayMessage(testValues, true);
          contactStore.setSearchContacts();
          setSubmitting(false);
        }}
        innerRef={formikRef}
      >
        {({ values, errors, touched, setFieldValue: setFieldValueFormik, handleSubmit, isSubmitting }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row gutter={[20, 20]} type="flex" justify="center">
                <Col md={20} span={24} className="text-start mb-5">
                  <div className="d-flex justify-content-center">
                    <Typography.Title level={4} className="fs-6">
                      Enter the Numbers
                    </Typography.Title>
                  </div>
                  <ContactSelector
                    isTestSms={true}
                    containerProps={{ colon: false }}
                    name="contacts"
                    contactDataField="numberList"
                    errors={errors}
                    touched={touched}
                    values={values}
                    setFieldValue={setFieldValueFormik}
                    onChange={e => {
                      if (!values.contacts.includes(getFormatedContacts(e)[e.length - 1])) {
                        setFieldValueFormik("contacts", getFormatedContacts(e));
                      }
                    }}
                    onDeselect={e => {
                      if (values.contacts.includes(e)) {
                        setFieldValueFormik(
                          "contacts",
                          values.contacts.filter(i => i !== e)
                        );
                        setFieldValueFormik("numberList", values.numberList?.filter(i => i.value !== e) || []);
                      }
                    }}
                    containerClassnames="mb-0"
                    secondary={false}
                  />
                </Col>
                <Col md={20} span={24} className="text-center mt-5">
                  <AppButton
                    label={isFirstTime ? `Send Test ${isMms ? "MMS" : "SMS"}` : `Resend Test ${isMms ? "MMS" : "SMS"}`}
                    type="submit"
                    light
                    withoutBg={!isFirstTime && !quickMessage}
                    disabled={isSubmitting}
                  />
                  {(skip || (saveAndContinue && !isFirstTime && !quickMessage)) && (
                    <AppButton
                      label={!isFirstTime ? "Next" : "Skip"}
                      type="button"
                      light
                      withoutBg={isFirstTime}
                      className="ms-3"
                      onClick={() => {
                        saveAndContinue();
                        handleCancel();
                      }}
                    />
                  )}
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default inject(stores => ({
  authStore: stores.store.authStore,
  modalStore: stores.store.modalStore,
  contactStore: stores.store.contactStore
}))(observer(TestSMS));
